const WINDOW_SECRET_KEYS = ['__LIQUID_INTERNAL_EDGE_SECRET__', '__INTERNAL_EDGE_SECRET__'] as const;
function normalizeSecret(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;
  const trimmed = value.trim();
  return trimmed ? trimmed : undefined;
}
function readFromWindow(): string | undefined {
  if (typeof window === 'undefined') return undefined;
  for (const key of WINDOW_SECRET_KEYS) {
    const candidate = normalizeSecret((window as Record<string, unknown>)[key]);
    if (candidate) return candidate;
  }
  const fallback = normalizeSecret((window as any).__ENV_VALIDATION__?.internalEdgeSecret);
  if (fallback) return fallback;
  try { return normalizeSecret(document?.querySelector?.('meta[name="x-internal-edge-secret"]')?.getAttribute?.('content')); }
  catch { return undefined; }
}
export function getInternalEdgeSecret(): string | undefined {
  // Try all possible sources in order of priority:
  // 1. Vite environment variables (development/build time)
  const viteSecret = normalizeSecret((import.meta as any)?.env?.VITE_INTERNAL_EDGE_SECRET)
    ?? normalizeSecret(typeof process !== 'undefined' ? process.env?.VITE_INTERNAL_EDGE_SECRET : undefined)
    ?? normalizeSecret(typeof process !== 'undefined' ? process.env?.INTERNAL_EDGE_SECRET : undefined);
  
  if (viteSecret) return viteSecret;
  
  // 2. Window-injected secrets (runtime)
  const windowSecret = readFromWindow();
  if (windowSecret) return windowSecret;
  
  // 3. Fallback for development/CI
  if (typeof process !== 'undefined' && process.env?.NODE_ENV === 'development') {
    return 'internal_edge_secret_for_local_dev_and_ci';
  }
  
  console.warn('[getInternalEdgeSecret] No internal secret found - admin functions will fail');
  return undefined;
}
